import { Controller } from "@hotwired/stimulus";
import I18n from "../../i18n.js";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";

// Connects to data-controller="forms--configuration-calendar"
export default class extends Controller {
  connect() {
    $(this.element).daterangepicker({
      linkedCalendars: false,
      timePicker: true,
      showCustomRangeLabel: false,
      timePicker24Hour: true,
      maxDate: `${new Date(
        new Date().setFullYear(new Date().getFullYear())
      ).toLocaleDateString(I18n.locale)}`,
      opens: "right",
      locale: {
        format: "MM/DD/YYYY HH:mm",
        applyLabel: I18n.t("flow_histories.index.daterangepicker.apply_label"),
        cancelLabel: I18n.t(
          "flow_histories.index.daterangepicker.cancel_label"
        ),
        daysOfWeek: [
          I18n.t("flow_histories.index.daterangepicker.su"),
          I18n.t("flow_histories.index.daterangepicker.mo"),
          I18n.t("flow_histories.index.daterangepicker.tu"),
          I18n.t("flow_histories.index.daterangepicker.we"),
          I18n.t("flow_histories.index.daterangepicker.th"),
          I18n.t("flow_histories.index.daterangepicker.fr"),
          I18n.t("flow_histories.index.daterangepicker.sa"),
        ],
        monthNames: [
          I18n.t("flow_histories.index.daterangepicker.january"),
          I18n.t("flow_histories.index.daterangepicker.february"),
          I18n.t("flow_histories.index.daterangepicker.march"),
          I18n.t("flow_histories.index.daterangepicker.april"),
          I18n.t("flow_histories.index.daterangepicker.may"),
          I18n.t("flow_histories.index.daterangepicker.june"),
          I18n.t("flow_histories.index.daterangepicker.july"),
          I18n.t("flow_histories.index.daterangepicker.august"),
          I18n.t("flow_histories.index.daterangepicker.september"),
          I18n.t("flow_histories.index.daterangepicker.october"),
          I18n.t("flow_histories.index.daterangepicker.november"),
          I18n.t("flow_histories.index.daterangepicker.december"),
        ],
      },
    });

    $(".ranges").remove();

    const i18nConfig = localStorage.getItem("i18nConfig");

    if (i18nConfig != "en") {
      $(this.element).val(
        moment(
          new Date($(this.element).val().split(" - ")[0]).toLocaleString(
            i18nConfig
          ),
          "DD/MM/YYYY HH:mm"
        ).format("DD/MM/YYYY HH:mm") +
          " - " +
          moment(
            new Date($(this.element).val().split(" - ")[1]).toLocaleString(
              i18nConfig
            ),
            "DD/MM/YYYY HH:mm"
          ).format("DD/MM/YYYY HH:mm") || " - "
      );
    }

    $(this.element).change(function (e) {
      if (i18nConfig == "en") {
        $("#configuration_custom_interval").val(
          moment(
            new Date(e.target.value.split(" - ")[0]).toLocaleString(i18nConfig),
            "MM/DD/YYYY HH:mm A"
          ).format("DD/MM/YYYY HH:mm") +
            " - " +
            moment(
              new Date(e.target.value.split(" - ")[1]).toLocaleString(
                i18nConfig
              ),
              "MM/DD/YYYY HH:mm A"
            ).format("DD/MM/YYYY HH:mm")
        );
      } else {
        $("#configuration_custom_interval").val(
          moment(
            new Date(e.target.value.split(" - ")[0]).toLocaleString(i18nConfig),
            "DD/MM/YYYY HH:mm"
          ).format("DD/MM/YYYY HH:mm") +
            " - " +
            moment(
              new Date(e.target.value.split(" - ")[1]).toLocaleString(
                i18nConfig
              ),
              "DD/MM/YYYY HH:mm"
            ).format("DD/MM/YYYY HH:mm")
        );
        $(this.element).val(
          moment(
            new Date(e.target.value.split(" - ")[0]).toLocaleString(i18nConfig),
            "DD/MM/YYYY HH:mm"
          ).format("DD/MM/YYYY HH:mm") +
            " - " +
            moment(
              new Date(e.target.value.split(" - ")[1]).toLocaleString(
                i18nConfig
              ),
              "DD/MM/YYYY HH:mm"
            ).format("DD/MM/YYYY HH:mm")
        );
      }
    });
  }
}
